import { createAppReducerSimpleFetch } from "shared/redux-store/defaults";

const orderGroupsOverviewAppReducerFetch = createAppReducerSimpleFetch(
  "ORDER_GROUPS_OVERVIEW",
  ["orderGroups"],
);

export default orderGroupsOverviewAppReducerFetch;
